module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("32cz7"))).then(() => parcelRequire('1iHdE'));